import { useState } from "react";
import { useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const startPassword = "";

export default function AdminLoginModal (props)
{
    const gDispatch = useDispatch();

    const [password, setPassword] = useState(startPassword);

    function hide ()
    {
	setPassword("");
	props.hide();
    }

    function handlePasswordChange (e) { setPassword(e.target.value); }

    function adminLogin ()
    {
	gDispatch({ type: "adminLogin", password });
	hide();
    }

    return (
	<Modal
	    size="sm"
	    show={props.show}
	    onHide={hide}
	    centered
	    animation={false}
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title>Mot de passe</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form className="d-flex flex-column gap-3 align-items-end">
		    <Form.Group className="w-100">
			<Form.Control autoFocus size="lg" type="password" className="text-center" value={password} onChange={handlePasswordChange} aria-label="Mot de passe"/>
		    </Form.Group>

		    <Button variant="primary" type="submit" disabled={password.length === 0} onClick={(e) => { e.preventDefault(); adminLogin(); }}>Valider</Button>
		</Form>
	    </Modal.Body>
	</Modal>
    );
}

